/**
 * A date typed into a date field (DatePicker's text input), year first like the date the field
 * shows: "1985-06-15", "1985/6/15", "1985.06.15", "1985 06 15" or "19850615".
 *
 * Day-first and month-first dates are not guessed: in Canada 03/04/1985 is read both ways, and a
 * wrong guess is a wrong date of birth on the lead. Returns a local-midnight Date, or null while
 * the text is not (yet) a real date, which is what vue-datepicker expects from its parser.
 */
const TYPED_DATE_REGEX = /^(\d{4})(?:[-/. ](\d{1,2})[-/. ](\d{1,2})|(\d{2})(\d{2}))$/;

export function parseTypedDate(text) {
    const match = String(text ?? '').trim().match(TYPED_DATE_REGEX);
    if (!match) {
        return null;
    }
    const year = Number(match[1]);
    const month = Number(match[2] ?? match[4]);
    const day = Number(match[3] ?? match[5]);
    const date = new Date(year, month - 1, day);
    // rejects 1985-02-30 and 1985-13-01, which Date would roll over into March and next January
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return null;
    }
    return date;
}
